export type TextDirection = "center" | "left" | "right" | "justify" | "char" | undefined
export type TableVariant = "DEFAULT" | "WITH_SUBTABLE"

export interface ITableColumn {
  field: string
  title: string
  isReplaceable?: boolean
  isHidden?: boolean
  isSortable?: boolean
  isMain?: boolean
  width?: string
}

export enum TableSortingOrder {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING"
}

export interface ITableSort {
  field: string
  type: TableSortingOrder
}

export type Item = Record<string, any>

export type ClickEventType = "single" | "double"
